import { getActionDescription } from 'helpers'
import { formatDatePMBV2 } from 'utils/formatDate'

export default function HistoryLine({ logs, showBorder = true }) {
  const getProjectLogMessage = (log) => {
    let name = log.userName || log.callerName || log.user?.name || '';
    if (name) name = name + ' ';
    
    let parsed;
    try {
      parsed = JSON.parse(log.extraData || '{}');
    } catch {
      parsed = {};
    }
    
    const resp = parsed?.resp || parsed?.res?.data || parsed?.req;
    const before = parsed?.before;
    
    if (log.action === "projects_create" || log.action === "project_create") {
      const title = resp?.title || "";
      return title
        ? `${name}membuat project "${title}"`
        : `${name}membuat project`;
    } else if (log.action === "project_update" || log.action === "projects_update") {
      if (before && resp) {
        const changes = [];
        if (
          before.status &&
          resp.status &&
          before.status !== resp.status
        )
          changes.push(
            `status dari ${before.status} menjadi ${resp.status}`
          );
        if (
          before.title !== undefined &&
          resp.title !== undefined &&
          before.title !== resp.title
        ) {
          changes.push(
            before.title ? `judul dari "${before.title}" menjadi "${resp.title}"` : `judul menjadi "${resp.title}"`
          );
        }
        if (
          before.label !== undefined &&
          resp.label !== undefined &&
          before.label !== resp.label
        ) {
          changes.push(
            before.label ? `label dari "${before.label}" menjadi "${resp.label}"` : `label menjadi "${resp.label}"`
          );
        }
        if (changes.length > 0)
          return `${name}mengubah project ${changes.join(" dan ")}`;
      }
      return `${name}mengubah project`;
    } else if (log.action === "project_updategoal") {
      if (resp?.currentAmount !== undefined) {
        return `${name}mengubah target project menjadi ${resp.currentAmount}`;
      } else {
        return `${name}mengubah target project`;
      }
    }
    return null;
  }

  const formatMessage = (msg) => {
    if (!msg) return msg
    return msg
      .replace(/ dari "" menjadi /g, ' menjadi ')
      .replace(/ dari "null" menjadi /g, ' menjadi ')
      .replace(/ dari null menjadi /g, ' menjadi ')
      .replace(/ dari undefined menjadi /g, ' menjadi ')
  }

  return (
    <div className="d-flex flex-column" data-testid="history-line">
      {logs?.map((log, index) => {
        const displayName = log.userName || log.callerName || log.user?.name;

        if ((log.modelName === 'projects' || log.action?.startsWith('project')) && !log.message?.trim()) {
          return null;
        }

        const projectMessage = log.modelName === 'projects' ? getProjectLogMessage(log) : null;
        const finalMessage = projectMessage || log.message;

        return (
          <div
            key={index}
            data-testid={`history-line-item-${index}`}
            className={`d-flex timeline-item ${!showBorder ? 'no-border' : ''}`}
          >
            <div className="timeline-icon">
              <span className="circle-icon-wrap">
                <span className="circle-icon"></span>
              </span>
            </div>

            <div className="timeline-content">
              <div className="text-sm flex align-items-center gap-2">
                {displayName && !finalMessage?.includes(displayName) && (
                  <>
                    <span>{displayName}</span>
                    <span> | </span>
                  </>
                )}
                <span style={{ color: '#475467' }}>
                  {formatDatePMBV2(log.createdAt)}
                </span>
              </div>
              <div className="mt-1">
                {finalMessage ? (
                  <span>{formatMessage(finalMessage)}</span>
                ) : log.modelName === 'projects' || log.action?.startsWith('project') ? (
                  <span>{log.description || log.action}</span>
                ) : (
                  getActionDescription(log)
                    .split(/(Berat tangkapan|Informasi hasil tangkapan|APPROVE)/)
                    .map((part, index) =>
                      part === 'APPROVE' ? (
                        <span key={index} style={{ color: '#05603A' }}>
                          {part}
                        </span>
                      ) : part === 'Berat tangkapan' ||
                        part === 'Informasi hasil tangkapan' ? (
                        <span key={index} style={{ fontWeight: 'bold' }}>
                          {part}
                        </span>
                      ) : (
                        <span key={index}>{part}</span>
                      ),
                    )
                )}
              </div>
              {log?.action === 'ap2hi_updateusercatchesfishes' &&
                log?.parsedExtraData?.before?.data?.fishes?.map((el, i) => {
                  if (
                    el?.amount !==
                    log?.parsedExtraData?.resp?.data?.fishes[i]?.amount
                  ) {
                    return (
                      <div className="text-xs" style={{ color: 'grey' }}>
                        <p className="mt-2 m-0">
                          - Berat tangkapan {el?.id} is changing from{' '}
                          {el?.amount} kg to{' '}
                          {log?.parsedExtraData?.resp?.data?.fishes[i]?.amount}{' '}
                          kg
                        </p>
                      </div>
                    )
                  }
                })}
              {log?.action === 'ap2hi_approveusercatches' &&
              log?.parsedExtraData?.req?.notes ? (
                <div
                  className="text-xs mt-1"
                  style={{
                    backgroundColor: '#F2F4F7',
                    padding: 15,
                    borderRadius: 7,
                  }}
                >
                  <span>{log?.parsedExtraData?.req?.notes}</span>
                </div>
              ) : null}
            </div>
          </div>
        )
      })}
    </div>
  )
}
